'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  border: solid 1px #cccccc;\n  background: #ffffff;\n  webkitoverflowscrolling: touch;\n  margin: 0px auto 0px auto;\n  outline: none;\n  height: ', ';\n  width: ', ';\n  padding: 0px;\n  border-radius: 0px 0px 8px 8px;\n  overflow-y: hidden;\n  overflow-x: auto;\n'], ['\n  border: solid 1px #cccccc;\n  background: #ffffff;\n  webkitoverflowscrolling: touch;\n  margin: 0px auto 0px auto;\n  outline: none;\n  height: ', ';\n  width: ', ';\n  padding: 0px;\n  border-radius: 0px 0px 8px 8px;\n  overflow-y: hidden;\n  overflow-x: auto;\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ModalDialogBase = require('./ModalDialogBase');
var _ModalDialogBase2 = _interopRequireDefault(_ModalDialogBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/**
 * Styling wrapper on top of the ModalDialog component.
 */
var ModalDialog = (0, _styledComponents2['default'])(_ModalDialogBase2['default'])(_templateObject, function (props) {
  return props.size == 'large' ? '90%' : '528px';
}, function (props) {
  return props.size == 'large' ? '90%' : '948px';
});
ModalDialog.defaultProps = {
  size: 'small'
};
ModalDialog.propTypes = {
  /**
   * The size of the component.
   */
  size: _propTypes2['default'].oneOf(['small', 'large'])
};
exports['default'] = ModalDialog;